import firebase from 'firebase'
import {config} from '../constants'

const getConfig = () => {
    try {
        return require('../CustomConfig')
    } catch (e) {
        return config.firebase
    }
}

firebase.initializeApp(getConfig());

firebase.firestore().settings({
    timestampsInSnapshots: true
});


// export const auth = firebase.auth();
// export const analytics = firebase.analytics();
export const firestore = firebase.firestore();
export const realtimeDB = firebase.database();

export const usersRef = firestore.collection('users')
export const tickersRef = firestore.collection('tickers')
export const tickerStateRef = firestore.collection('currentTicker')
export const directMessagesRef = firestore.collection('directMessages')

export const questionsRef = firestore.collection('qaGroupChat')
export const ballroomOnlineChatRef = firestore.collection('onlineChat')
export const awardWinnersRef = firestore.collection('awardWinners')
export const ballRoomSettings = firestore.collection('ballroomSettings')

export const socialWallRef = firestore.collection('socialWall')
export const conversationRef = firestore.collection('conversationChat')
export const feedbackRef = firestore.collection('feedback')

export const feedbackReportRef = firestore.collection('feedbackReport')
export const eventReportRef = firestore.collection('eventReport')
